import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "@/locales/en.json";
import ru from "@/locales/ru.json";
import de from "@/locales/de.json";
import fr from "@/locales/fr.json";
import el from "@/locales/el.json";
import ar from "@/locales/ar.json";
import he from "@/locales/he.json";
import zh from "@/locales/zh.json";
import pl from "@/locales/pl.json";
import tools_en from "@/locales/tools/en.json";
import tools_ru from "@/locales/tools/ru.json";
import tools_de from "@/locales/tools/de.json";
import tools_fr from "@/locales/tools/fr.json";
import tools_el from "@/locales/tools/el.json";
import tools_pl from "@/locales/tools/pl.json";
import tools_ar from "@/locales/tools/ar.json";
import tools_he from "@/locales/tools/he.json";
import tools_zh from "@/locales/tools/zh.json";

export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English", short: "EN", flag: null },
  { code: "ru", label: "Русский", short: "RU", flag: "ru" },
  { code: "de", label: "Deutsch", short: "DE", flag: "de" },
  { code: "fr", label: "Français", short: "FR", flag: "fr" },
  { code: "el", label: "Ελληνικά", short: "EL", flag: "gr" },
  { code: "pl", label: "Polski", short: "PL", flag: "pl" },
  { code: "ar", label: "العربية", short: "AR", flag: "ae" },
  { code: "he", label: "עברית", short: "HE", flag: "il" },
  { code: "zh", label: "中文", short: "ZH", flag: "cn" },
];

export const RTL_LANGUAGES = ["ar", "he"];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: { ...en, tools: tools_en } },
      ru: { translation: { ...ru, tools: tools_ru } },
      de: { translation: { ...de, tools: tools_de } },
      fr: { translation: { ...fr, tools: tools_fr } },
      el: { translation: { ...el, tools: tools_el } },
      pl: { translation: { ...pl, tools: tools_pl } },
      ar: { translation: { ...ar, tools: tools_ar } },
      he: { translation: { ...he, tools: tools_he } },
      zh: { translation: { ...zh, tools: tools_zh } },
    },
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "corporaco_lang",
    },
  });

export default i18n;
